<template>
    <div class="scrollableY">
        <div class="container has-text-centered wideLimitWidth">
            <!-- <div class="is-size-3 top60 has-text-light">Check out this awesome miimu!</div -->>
            <div class="is-size-3 has-text-light"><b>{{item.fName}} {{item.lName}}</b><br>shared this <b class="has-text-coolGreen">miimu</b> with you</div>
            <br>
            <div>
                <card-shared  ref="c" v-bind:cardInfo="item"></card-shared>
            </div>
    
            <!-- <div class="has-text-light pad10 has-background-dark top40"><b>Use the buttons to navigate to this link or import this miimu into your account.</b></div>
            <div v-show="$root.app.isAuth == false" class="pad10">Don't have an account? Register <b class="has-text-coolGreen" @click="$router.push('/register')">here</b></div> -->
           
            <div class="top20 is-size-5 has-text-centered has-text-white"><b>Click below to import this miimu</b> <br>
                    <button v-show="!notFound" id="mainButt" class="button is-coolGreen top10 right10"  @click="openEdit">IMPORT</button>
            </div>
            <div></div>
    
        </div>
    </div>
</template>
    
<script>
import CardShared from '../components/CardShared'
export default{
    components: {CardShared},
    data: function(){
        return {
            inited: false,
            item: {}
        }
    },
    mounted: function(){
         //get account values from DB
       var self = this;

       window.scrollTo(0,0)
       setTimeout(function(){
            document.getElementById('miimuMenu').classList.remove('is-active');
       }, 5)
       

        self.worked = function (d) {
            //az.addRemSpinner(false, 'id', 'form1');
            self.item = d.item
           
        }
        self.noWorked = function (data, status, headers, config, msg, errorRequest) {
            //az.addRemSpinner(false, 'id', 'form1');
            //self.$root.showModalOK({message: data})
        }

        //function init(){
            //az.addRemSpinner(true, 'id', 'form1');
        self.$root.app.apiClient.get('open/confirm/og/' + self.$route.query.p, {}, self.worked, self.noWorked);
        //}

        

        /* if(self.$root.app.doneFederating){
            self.inited = true
            init();
        }

        AZEventBus.$once('onFederate', msg => {
          if(self.inited == false)
            init();
        }); */
    },

    methods: {

        openEdit: function(){

            var c = this.$refs.c
           
            if(!this.$root.app.isAuth){
                this.$root.app.showModalLogin()
                return
            }
            c.item.shareId = c.shareId
            this.$root.app.doShowModal('editModal', {cardPack: c.item, callApi: false})
        }
    }

   
}

</script>